<template>
<div class="breadcrumb-line">
  <div class="breadcrumb-line-title">您所在位置：</div>
  <el-breadcrumb class="app-breadcrumb" separator="·">
    <el-breadcrumb-item v-for="(item, index) in levelList" :key="index">
      <span v-if="item.meta.isRedirect===false" class="no-redirect">
        <!-- <span v-if="index==0" class="iconfontBread icon-breadcrumb"></span> -->
        {{item.meta.title}}
      </span>
      <a v-else @click.prevent="handleLink(item)" class="yes-redirect">
        <!-- <span v-if="index==0" class="iconfontBread icon-breadcrumb"></span> -->
        {{item.meta.title}}
      </a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta.title);
      //面包屑第一项：带首页
      /** 
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      } 
      */
      this.levelList = matched.filter(item => item.meta && item.meta.title);
      
      /**面包屑最后一级不跳转  by li.xue 2019/2/14 */
      if(this.levelList!=null && this.levelList.length>1){
        for(var i in this.levelList){
          if(i == 0){
            if(!this.levelList[i].meta.isRedirect){
              this.levelList[i].meta.isRedirect = false;
            }
          }else if(i == this.levelList.length-1){
            this.levelList[i].meta.isRedirect = false;
          }else{
            this.levelList[i].meta.isRedirect = true;
          }
        }
      }
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { path } = item;
      if (path) {
        this.$router.push(path);
        return;
      }
      // this.$router.push(this.pathCompile(path));
      this.$router.back(-1);
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .breadcrumb-line {
    position: relative;
    display: flex;
    height: 1.2rem;
    flex-shrink: 0;
    margin: 10px 0px 15px 5px;
    .breadcrumb-line-title {
      width: 100px;
      margin-left: 16px;
      font-size: 15px;
    }
    .iconfontBread {
      font-family: "iconfont" !important;
    }
    .app-breadcrumb.el-breadcrumb {
      flex: 1;
      // display: inline-block;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.5;
      .no-redirect {
        color: #666666;
        cursor: text;
      }
      .yes-redirect {
        color: #1989FA;
        cursor: pointer;
      }
      .el-breadcrumb__inner .no-redirect {
        color: #666666;
      }
    }
    .el-breadcrumb__item {
      &:first-child {
        .no-redirect {
          color: #666666 !important;
        }
      }
    }
    &::before {
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      height: 0.875rem;
      width: 4px;
      background-color: #1989FA;
    }
  }
  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link {
    font-weight: 400 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/index.vue